<template>
    <v-card>
        <v-container fluid class="px-6 pt-4 pb-8">
            <v-row>
                <v-col md="7">
                    <v-autocomplete
                        v-model="ownedFacilityKeys"
                        :items="allFacilities"
                        item-text="title"
                        item-value="facility_key"
                        multiple
                        chips
                        deletable-chips
                        @change="canSave = true"
                        class="facility-select"
                    ></v-autocomplete>
                </v-col>
                <v-col md="5">
                    <v-card-actions>
                        <v-btn class="ies-green" @click="saveOwnedFacilities()" :disabled="!canSave"><v-icon>save</v-icon> Save</v-btn>
                        <v-btn class="ies-coral" @click="removeAllOwnedFacilities()" :disabled="!ownedFacilityKeys.length">Remove All</v-btn>
                        <v-btn @click="loadAllFacilities()"><v-icon>refresh</v-icon> Refresh</v-btn>
                        <v-btn href="/facilities/list" target="_blank"><v-icon>library_add</v-icon> Library</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user choose which facilities to
     * add to the hotel
     *
     * Props:
     *     int 'facility-type' - The numeric value representing what type of facilities this component is responsible for (e.g dining)
     *     int 'availability'  - Bitwise integer representing whether the facility is available to the entire hotel (=1) or just rooms (=2) or both (=3)
     */

    import axios from 'axios';

    export default {
        name: 'hotel-facility-manager',
        props: ['hotelkey', 'facilityType', 'availability'],
        data() {
            return {
                /** @var {} allFacilities - The full spectrum of facilities that the i-escape system can understand */
                allFacilities:    [],

                /** @var [] ownedFacilityKeys - The facility_key values for all facilities this hotel owns */
                ownedFacilityKeys: [],

                /** @var boolean canSave - Used to disable the save button if there are no changes */
                canSave:          false,
            }
        },
        methods: {
            /**
             * @see data allFacilities
             */
            loadAllFacilities() {
                axios.get('/api/facilities/', { params: { facilityCategory: this.facilityType } })
                    .then(response => {
                        this.allFacilities = response.data;
                    });
            },

            /**
             * @see data ownedFacilityKeys
             */
            loadOwnedFacilities() {
                axios.get('/api/hotel-facilities/' + this.hotelkey, { params: { facilityCategory: this.facilityType, availability: this.availability ? this.availability : 1 } })
                    .then(response => {
                        this.ownedFacilityKeys = response.data.map(f => f.facility_key);
                    });
            },

            removeAllOwnedFacilities() {
                this.ownedFacilityKeys = [];
                this.canSave = true;
            },

            /**
             * Makes a POST request to the API to save the ownership of the
             * facilities that the user has chosen
             */
            saveOwnedFacilities() {
                axios.post('/api/hotel-facilities/' + this.hotelkey, {
                    params: {
                        facilityCategory: this.facilityType,
                        facilityKeys:     this.ownedFacilityKeys,
                        availability:     this.availability ? this.availability : 1,
                    }
                }).then(() => {
                    alert('Saved');
                    this.canSave = false;
                });
            },
        },
        /**
         * On mounted this component needs to load all available facilities and
         * all those owned by this hotel
         */
        mounted() {
            // Obtain all facilities the i-escape system understands
            this.loadAllFacilities();

            // Obtain a list of the facilities this hotel actually owns
            this.loadOwnedFacilities();
        },
    }
</script>

<style>


.facility-select .v-icon {
    cursor: pointer;
}

</style>
